import { useMutation, useQueryClient } from '@tanstack/react-query'
import React from 'react'
import toast from 'react-hot-toast';
import { addIdentificationMarket } from 'services/apiComparable';

const useAddIdentiMarket = () => {
  const queryClient = useQueryClient();

  const{isPending: isAdding, isSuccess: isAdded, mutate: addIdenMarket} = useMutation({
    mutationFn: addIdentificationMarket,
    onSuccess:(data)=>{
        queryClient.setQueryData(['newIdenMarketData'],data)
        toast.success("Added Successfully")
        queryClient.invalidateQueries({queryKey:['existingIdenMarketData']})
    },
    onError:(error)=>{
        console.log("Error occurred when creating Org",error)
                if (error?.data && typeof error.data === 'object') {
                // Display all backend validation errors
                for (const key in error.data) {
                    const msg = error.data[key];
                    toast.error(Array.isArray(msg) ? msg[0] : msg);
                }
            } else {
                toast.error(error.message || "Something went wrong.");
            }
    }
  })
  return{isAdding, isAdded, addIdenMarket}
}

export default useAddIdentiMarket